module.exports = __webpack_public_path__ + "static/media/37-1.256045f3.mp3";